module.exports = __webpack_public_path__ + "img/FR11380.d3a6f9ce.png";